import ParsingDfa4Table from "../../parsing/parsing_dfa_4table.js";
/**
 * DFA State machine states for parsing an identifier.
 */
var IDENTIFIER_PARSER_STATE;
(function (IDENTIFIER_PARSER_STATE) {
    IDENTIFIER_PARSER_STATE[IDENTIFIER_PARSER_STATE["TERMINUS"] = 0] = "TERMINUS";
    IDENTIFIER_PARSER_STATE[IDENTIFIER_PARSER_STATE["MUST_UPPER_CASE"] = 1] = "MUST_UPPER_CASE";
    IDENTIFIER_PARSER_STATE[IDENTIFIER_PARSER_STATE["FOLLOW_ON_UPPER_CASE"] = 2] = "FOLLOW_ON_UPPER_CASE";
})(IDENTIFIER_PARSER_STATE || (IDENTIFIER_PARSER_STATE = {}));
const IDENTIFIER_TERMINUS_FLAGS = (1 << IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE);
/**
 * Parse a step entity identifier - expecting this token to be [A-Z]([A-Z,0-9,_]*),
 * as they are parsed in upper case.
 */
export default class StepEntityIdentifierParser extends ParsingDfa4Table {
    /**
     * Construct the DFA parser state.
     */
    constructor() {
        super();
        /**
         * Match a step enum
         *
         * @param input The input buffer
         * @param cursor The position in the buffer to test for the match.
         * @param endCursor The end position in the buffer by which the match must terminate.
         * @return {number | undefined} The length of the match or undefined.
         */
        this.match = (input, cursor, endCursor) => {
            return super.match(input, IDENTIFIER_TERMINUS_FLAGS, cursor, endCursor, IDENTIFIER_PARSER_STATE.MUST_UPPER_CASE);
        };
        this.range(IDENTIFIER_PARSER_STATE.MUST_UPPER_CASE, "A", "Z", IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE);
        this.range(IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE, "A", "Z", IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE);
        this.range(IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE, "0", "9", IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE);
        this.set(IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE, "_", IDENTIFIER_PARSER_STATE.FOLLOW_ON_UPPER_CASE);
    }
}
StepEntityIdentifierParser.Instance = new StepEntityIdentifierParser();
